// PRODUCT-IA-CLEANUP-001A: the five primary project workspaces after the
// navigation cleanup — Content, DNA, Media, Connections, Analytics.
// `feeds` is an internal-tester-only extra, deliberately NOT part of the
// primary product structure (task section 1) but still a valid, directly
// addressable view for the accounts that can reach it.
export const PRIMARY_PROJECT_VIEWS = ['content', 'dna', 'media', 'connections', 'analytics', 'feeds'];

// Every pre-cleanup `activeView`/tab id, mapped to its replacement primary
// workspace plus (when applicable) the contextual sub-destination inside
// it — the exact table from task section 8. `list`/`project` are the two
// historical ids for the same default Content view (top-level `activeView`
// used `project`; ProjectView's own internal tab state used `list`).
const LEGACY_VIEW_MAP = {
  project: { view: 'content', subTab: 'all' },
  list: { view: 'content', subTab: 'all' },
  calendar: { view: 'content', subTab: 'calendar' },
  personas: { view: 'dna', subTab: 'personas' },
  creative: { view: 'dna', subTab: 'moodboard' },
  design: { view: 'dna', subTab: 'design' },
  library: { view: 'media', subTab: null },
  social: { view: 'connections', subTab: 'social' },
  // The removed legacy Pro/Content-Master historical workspace tab falls
  // back safely to Content — it never produces a blank or dead view.
  pro: { view: 'content', subTab: 'all' },
};

// Resolves ANY raw view id (a fresh new-architecture id, a legacy
// pre-cleanup id, or something unrecognized/corrupted) to a safe
// `{ view, subTab }` pair. Never throws, never returns an unmapped/blank
// destination — anything unrecognized safely falls back to Content/All.
export function resolveProjectView(rawView) {
  if (PRIMARY_PROJECT_VIEWS.includes(rawView)) {
    return { view: rawView, subTab: null };
  }
  if (Object.prototype.hasOwnProperty.call(LEGACY_VIEW_MAP, rawView)) {
    return LEGACY_VIEW_MAP[rawView];
  }
  return { view: 'content', subTab: 'all' };
}
